<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="lg"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="sale-registration-add"
    >
      <template v-slot:modal-title>Pagar pensión</template>
      <section class="container-fluid">
        <section v-if="registration.id !== null">
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <form @submit.prevent="add">
              <section class="row">
                <!-- Estudiante -->
                <div class="col-6">
                  <div class="form-group required">
                    <label class="control-label" for="type">Estudiante</label>
                    <p>
                      {{ registration.student_fullname }}
                    </p>
                  </div>
                </div>
                <!-- Saldo de adelanto -->
                <div class="col-6" v-if="student.credit > 0">
                  <div class="form-group">
                    <label class="control-label" for="credit"
                      >Saldo de adelanto
                    </label>
                    <p :class="messageCredit == '' ? '' : 'mb-0'">
                      Bs. {{ student.credit | currency }}
                    </p>
                    <small class="text-danger">{{ messageCredit }}</small>
                  </div>
                </div>
              </section>

              <section class="row">
                <!-- Curso -->
                <div class="col">
                  <div class="form-group">
                    <label class="control-label" for="course_offered"
                      >Curso</label
                    >
                    <p>
                      {{
                        `${registration.course_name} (${registration.courses_offered_parallel})`
                      }}
                    </p>
                  </div>
                </div>
                <!-- Categoria Pensión -->
                <div class="col">
                  <div class="form-group">
                    <label class="control-label" for="syllabus_tuition"
                      >Categoria Pensión</label
                    >
                    <p>
                      {{ registration.syllabus_tuition_name }} - Bs.
                      {{ registration.tuition_price | currency }}
                    </p>
                  </div>
                </div>
              </section>

              <section class="row">
                <!-- Multas -->
                <div class="col">
                  <div class="form-group">
                    <ValidationProvider
                      name="total_fines"
                      :rules="validationSaleTotalFines"
                      v-slot="{ valid, errors }"
                    >
                      <label class="control-label" for="total_fines"
                        >Multas
                      </label>
                      <currency-input
                        v-model="registration.sale.total_fines"
                        class="form-control form-control-sm"
                        id="total_fines"
                      />
                      <b-form-invalid-feedback :state="valid">{{
                        errors[0]
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- Total con multas -->
                <div class="col">
                  <div class="form-group">
                    <label
                      class="control-label"
                      for="total_with_discounts_and_fines"
                      >Total con multas
                    </label>
                    <currency-input
                      v-model="registration.sale.total_with_discounts_and_fines"
                      class="form-control form-control-sm"
                      id="total_with_discounts_and_fines"
                      readonly
                    />
                  </div>
                </div>
              </section>
              <section class="row">
                <!-- Cliente -->
                <div class="col-6">
                  <div class="form-group required">
                    <ValidationProvider
                      name="customer_id"
                      rules="required"
                      v-slot="{ valid, errors }"
                    >
                      <label class="control-label" for="customer_id"
                        >Cliente</label
                      >
                      <b-input-group>
                        <v-select
                          label="name"
                          :options="customersOptions"
                          @search="onSearchCustomers"
                          v-model="registration.customer_id"
                          :reduce="(customer) => customer.id"
                          id="customer_id"
                          style="width: calc(100% - 63px)"
                          placeholder="Buscar Cliente"
                        >
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              No hay resultados para <em>{{ search }}</em
                              >.
                            </template>
                            <em v-else>Buscar Cliente</em>
                          </template>
                          <template v-slot:option="option">
                            <span :class="option.icon"></span>
                            {{ `${option.name}` }}
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ `${option.name}` }}
                            </div>
                          </template>
                        </v-select>
                        <b-input-group-append>
                          <button
                            @click="customerAddMod"
                            class="btn btn-success btn-sm"
                            type="button"
                          >
                            <CIcon size="sm" name="cib-Addthis" />
                          </button>
                        </b-input-group-append>
                        <button
                          @click="customerListMod"
                          class="btn btn-info btn-sm"
                          type="button"
                        >
                          <CIcon size="sm" name="cil-list" />
                        </button>
                      </b-input-group>
                      <b-form-invalid-feedback :state="valid">{{
                        errors[0]
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                </div>
              </section>

              <section class="row">
                <!-- Formas de pago -->
                <div class="col">
                  <PaymentMethodRadioInput
                    v-model="registration.payment_method_id"
                    :name="'payment_method_id'"
                    :rules="'required'"
                    :value="registration.payment_method_id"
                    :disabled="registration.payment_method_id == 6"
                  />
                </div>
                <!-- Observación de pago -->
                <div class="col">
                  <div class="form-group">
                    <ValidationProvider
                      name="observation"
                      rules="max:180"
                      v-slot="{ valid, errors }"
                    >
                      <label class="control-label" for="observation"
                        >Observación de pago</label
                      >
                      <input
                        type="text"
                        v-model="registration.sale.observation"
                        class="form-control form-control-sm"
                        id="observation"
                        maxlength="180"
                      />
                      <b-form-invalid-feedback :state="valid">{{
                        errors[0]
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                </div>
              </section>

              <b-button type="button" size="sm" variant="danger" @click="close">
                <CIcon size="sm" name="cil-x-circle" /> Cancelar
              </b-button>

              <button
                type="submit"
                class="btn btn-success btn-sm float-right"
                variant="success"
                :disabled="invalid || addLoader"
              >
                <span v-if="!addLoader">
                  <CIcon size="sm" name="cil-save" /> Guardar
                </span>
                <span v-if="addLoader">
                  Cargando
                  <CSpinner color="success" size="sm" />
                </span>
              </button>
            </form>
          </ValidationObserver>
        </section>
        <section v-else class="row">
          <div class="col">
            <p>Cargando datos...</p>
          </div>
        </section>
      </section>
    </b-modal>
    <!-- add customer -->
    <section v-if="modShowCustomerAdd">
      <CustomerAddModal
        :modShowCustomerAdd="modShowCustomerAdd"
        @customerAddModal="afterAddCustomer"
      >
      </CustomerAddModal>
    </section>
    <!-- listar customer -->
    <section v-if="modShowCustomerList">
      <CustomerListModal
        :modShowCustomerList="modShowCustomerList"
        @customerListModal="afterListCustomer"
      >
      </CustomerListModal>
    </section>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max, max_value } from "vee-validate/dist/rules";
import Constants from "@/plugins/constants";
//services
import Registrations from "@/plugins/services/registrations";
import Students from "@/plugins/services/students";
import Customers from "@/plugins/services/customers";
import Sales from "@/plugins/services/sales";
//components
import PaymentMethodRadioInput from "@/entities/payment-methods/PaymentMethodRadioInput";
import CustomerAddModal from "@/entities/customers/CustomerAddModal";
import CustomerListModal from "@/entities/customers/CustomerListModal";

export default {
  name: "SaleRegistrationAddModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    PaymentMethodRadioInput,
    CustomerAddModal,
    CustomerListModal,
  },
  props: {
    modShowSaleRegistrationAdd: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
    registration_id: { type: Number, required: true },
  },
  data() {
    return {
      registration: {
        id: null,
        payment_method_id: 5,
        tuition_price: 0,
        sale: {
          observation: "",
          total_fines: 0,
          total_with_discounts_and_fines: 0,
        },
      },
      student: {},
      mode: { shape: "pill" },
      color: "primary",
      addLoader: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
      loaderPaid: true,
      customersOptions: [],
      modShowCustomerAdd: false,
      modShowCustomerList: false,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowSaleRegistrationAdd;
    },
    validationSaleTotalFines() {
      if (
        this.student.credit >= this.registration.tuition_price &&
        this.registration.tuition_price > 0
      ) {
        let max_value = this.student.credit - this.registration.tuition_price;
        return `required|max_value:${max_value}`;
      } else {
        return "required";
      }
    },
    messageCredit() {
      if (
        this.student.credit < this.registration.tuition_price &&
        this.student.credit > 0 &&
        this.registration.tuition_price > 0
      ) {
        return "El saldo de crédito es insuficiente para pagar por adelantado";
      }
      return "";
    },
  },
  mounted() {
    this.addLoader = false;
    this.getDataStudent(this.student_id);
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("max_value", {
      ...max_value,
      message: "Por favor, escribe un valor menor o igual a {max}.",
    });
  },
  watch: {
    "registration.sale.total_fines": function (total_fines) {
      if (total_fines >= 0) {
        this.registration.sale.total_with_discounts_and_fines =
          this.registration.tuition_price + total_fines;
      } else {
        this.registration.sale.total_with_discounts_and_fines =
          this.registration.tuition_price;
      }
    },
  },
  methods: {
    add() {
      this.addLoader = true;
      this.registration.created_by = this.userAuth.username;
      this.registration.student_id = this.student_id;
      this.registration.user_id = this.userAuth.id;
      Sales.registrationAdd(this.registration.id, this.registration)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            // si no es adelanto
            if (this.registration.payment_method_id !== 6) {
              let registrationUrl = `${process.env.MIX_APP_API_ENDPOINT}/registrations/pdf/${res.data.data.id}`;
              Utils.printPdf(registrationUrl);
            }
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Item no encontrado.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    getDataStudent(id) {
      Students.getData(id)
        .then((res) => {
          this.student = res.data;
          if (this.student.customer_id !== null) {
            this.registration.customer_id = this.student.customer_id;
            this.getCustomerById(this.student.customer_id);
          }
          this.getDataRegistration(this.registration_id);
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.close();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.close();
          }
        });
    },
    getDataRegistration(id) {
      Registrations.getOne(id)
        .then((res) => {
          this.registration = { ...this.registration, ...res.data };
          this.registration.customer_id = this.student.customer_id;

          this.registration.sale.total_with_discounts_and_fines =
            this.registration.tuition_price;
          // verificar si es estudiante tiene credito, si tiene credito
          // programar con el credito pero no generar factura
          if (
            this.student.credit >= this.registration.tuition_price &&
            this.registration.tuition_price > 0
          ) {
            this.registration.payment_method_id = 6;
          } else {
            this.registration.payment_method_id = 5;
          }
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programación no encontrada.");
            this.close();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.close();
          }
        });
    },
    // search Customers
    onSearchCustomers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getCustomers(loading, search);
      }
    },
    getCustomers(loading = null, search = null) {
      Customers.selectAll(search)
        .then((res) => {
          this.customersOptions = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
        });
    },
    getCustomerById(id) {
      Customers.selectAllById(id)
        .then((res) => {
          this.customersOptions = res.data;
          if (this.customersOptions.length == 0) {
            this.registration.customer_id = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    customerAddMod() {
      this.modShowCustomerAdd = true;
    },
    afterAddCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.registration.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerAdd = response.modalShow;
    },
    customerListMod() {
      this.modShowCustomerList = true;
    },
    afterListCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.registration.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerList = response.modalShow;
    },
    closeModal(data = null, status = 200) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("saleRegistrationAddModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
